import { axiosInstance as axios } from "services";

export const updateRepairPolicy = async (id, data) => {
  const { data: res } = await axios.patch(`/admin/repairPolicyMaster/${id}`, data);
  if (!res.success) throw new Error(res.error || "Failed to update repair policy");
  return res;
};
